import React from 'react';
import BreakdownContent, {
  BreakdownContentProps,
} from '@components/progress/breakdown/BreakdownContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { useAtom, useAtomValue } from 'jotai';
import {
  selectedBreakdownIdAtom,
  selectedBreakdownTopicAtom,
} from '@components/progress/ProgressStore';
import moment from 'moment';

const BreakdownSection = () => {
  const [selectedBreakdownId, setSelectedBreakdownId] = useAtom(
    selectedBreakdownIdAtom,
  );
  const selectedBreakdownTopic = useAtomValue(selectedBreakdownTopicAtom);

  const lastAttempt = moment(
    selectedBreakdownTopic?.last_attempted_date + '+08:00',
  );
  const now = moment();
  const duration = moment.duration(lastAttempt.diff(now));

  const formattedDuration = duration.humanize(true, {
    M: 12,
    w: 5,
    d: 7,
    h: 24,
    m: 60,
    s: 60,
  });

  const contentProps: BreakdownContentProps = {
    easy: selectedBreakdownTopic?.percentage_easy || 0,
    hard: selectedBreakdownTopic?.percentage_hard || 0,
    medium: selectedBreakdownTopic?.percentage_medium || 0,
    total_easy_attempt: selectedBreakdownTopic?.total_easy_attempt || 0,
    total_medium_attempt: selectedBreakdownTopic?.total_medium_attempt || 0,
    total_hard_attempt: selectedBreakdownTopic?.total_hard_attempt || 0,
    overall_percentage: selectedBreakdownTopic?.overall_percentage || 0,
    watchTime: selectedBreakdownTopic?.watch_time || 0,
    questionAttempted: selectedBreakdownTopic?.total_attempts || 0,
    skillLevel: selectedBreakdownTopic?.student_score || 0,
    lastPractised: selectedBreakdownTopic?.last_attempted_date
      ? formattedDuration
      : '-',
    topicId: selectedBreakdownTopic?.topic_id || '0', // to get Watch Time when selecting one of the topic
  };

  if (!selectedBreakdownId || !selectedBreakdownTopic) {
    return null;
  }

  return (
    <>
      <div
        className={
          'max-lg:hidden rounded-2xl mb-2 bg-primary-navyblue-shade/[0.65] px-6 py-6 pt-4'
        }
        id={'breakdown-section'}
      >
        <div className={'flex justify-between mb-6'}>
          <div
            className={
              'font-extrabold text-neutral-chalk text-md leading-[1.2]'
            }
          >
            {selectedBreakdownTopic.topic_name}
          </div>
          <div
            className={'cursor-pointer'}
            data-testid={'close-button'}
            onClick={() => setSelectedBreakdownId(null)}
          >
            <FontAwesomeIcon
              icon={faXmark}
              className={'text-primary-apricot'}
            />
          </div>
        </div>
        <BreakdownContent {...contentProps} />
      </div>
      <div
        className={
          'lg:hidden fixed w-full h-full z-[1000] left-0 top-0 px-6 pb-6 pt-4 bg-cover bg-fixed bg-no-repeat bg-primary-navyblue-dark bg-[url("/public/img/Background_Default_1.svg")]'
        }
      >
        <div className={'flex justify-start mb-6'}>
          <div
            className={'cursor-pointer mr-4'}
            data-testid={'back-button'}
            onClick={() => setSelectedBreakdownId(null)}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              className={'text-primary-apricot'}
            />
          </div>
          <div
            className={
              'font-extrabold text-neutral-chalk text-md leading-[1.2]'
            }
          >
            {selectedBreakdownTopic.topic_name}
          </div>
        </div>
        <BreakdownContent {...contentProps} />
      </div>
    </>
  );
};

export default BreakdownSection;
